import React from 'react';
import ProjectContainer from '../../containers/projectmng/ProjectContainer';

const MaintanceDetailPage = () => {
  const pageUrl="/maintancetmng";
  return <ProjectContainer pageUrl={pageUrl}/>
};

export default MaintanceDetailPage;
